import { useRouter } from 'next/router';

export const useGetUrlPath = () => {
  const router = useRouter();
  const path = router.asPath;

  return path.includes('.html') ? path.split('.html')[0] : path;
};
